Ext.define('SA.view.mapexport.StandardSizesComboBox', {
    alias: 'widget.export-standard-sizes-combo',
    extend: 'SA.view.ComboButton',

    initComponent() {
        this.callParent();

        this.mon(this.details, {
            'set:height': this.refresh,
            'set:width': this.refresh,

            buffer: 10,
            scope: this
        });
    },

    afterRender() {
        this.callParent();
        this.refresh();
    },

    refresh() {
        var {details} = this,
            {sizes} = SA.model.map.PaperSize,
            width = Math.min(details.getWidth(), details.getHeight()),
            height = Math.max(details.getWidth(), details.getHeight()),
            items = Object.keys(sizes),
            value = items.find(sizeName => sizes[sizeName].getWidth() === width && sizes[sizeName].getHeight() === height);

        if (!value) {
            value = 'Custom';

            items.push('Custom');
        }

        this.setItemsAndValue(items, value);
    }
});